<template>
  <el-dialog :title="title" :visible.sync="centerDialogVisible" :width="width" center>
    <div class="dialogstyle" :style="dialogType ? 'height:126px':''">
      <img v-if="dialogType === 'success'" src="../../assets/success.png" alt="">
      <img v-if="dialogType === 'warning'" src="../../assets/warning.png" alt="">
      <img v-if="dialogType === 'remind'" src="../../assets/remind.png" alt="">
      <img v-if="dialogType === 'delete'" src="../../assets/trashicon.png" alt="">
       <img v-if="dialogType === 'sighicon'" src="../../assets/sighicon.png" alt="">
      <div>
        <span>{{content}}</span>
      </div>
    </div>
    <span v-if="footBtn === 'button'" slot="footer" class="dialog-footer">
      <el-button @click="cancel">{{cancel_buttton}}</el-button>
      <el-button type="primary" @click="ok">{{ok_buttton}}</el-button>
    </span>
    <div v-if="footBtn === 'card'" slot="footer" class="tableBtn">
      <div @click="ok" style="color:#00b882">{{ok_buttton}}</div>
      <div @click="cancel" style="color:#a7a7a7">{{cancel_buttton}}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  // name: 'dialog',
  data() {
    return {
      //显示标题，默认为“提示”
      title: '提示',
      //显示内容
      content: '',
      //左按钮显示文本，默认为“取消”
      cancel_buttton: '取消',
      //右按钮显示文本，默认为“确定”
      ok_buttton: '确定',
      //提示类型 icon
      dialogType: '',
      //底部按钮是否显示
      footBtn: '',
      centerDialogVisible: true,
      width: '30%',
    }
  },
  methods: {
    //点击取消按钮
    cancel() {
      this.onCancel()  //点击取消的回调函数
      this.$destroy(true)  //销毁组件
      this.$el.parentNode.removeChild(this.$el)  //父元素中移除dom元素（$el为组件实例）
    },
    //点击确定按钮
    ok() {
      this.onOk()  //点击确定的回调函数
      this.$destroy(true)  //销毁组件
      this.$el.parentNode.removeChild(this.$el)  //父元素中移除dom元素（$el为组件实例）
    }
  }
}
</script>

<style lang='scss' scoped>
.dialog-footer {
  margin-bottom: 20px;
  display: block;
  padding: 20px;
}
.dialogstyle {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
  }
  div {
    margin-top: 24px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/index.vue